import styled from "styled-components";
import BackgroundImage from "../../Assets/BG.svg";
import { FlexWrapper } from "../../Components/Common";
import BottomImage from "../../Assets/bg/homepage-image2.png";

export const MainWrapper = styled.div`
  width: "100vw";
  background-color: #060310;
`;

export const HeroSectionWrapper = styled.div`
  width: 100%;
  height: 100vh;
  background: url(${BackgroundImage});
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const GifImage = styled(FlexWrapper)`
  background: rgba(229, 229, 229, 0.12);
  backdrop-filter: blur(50px);
  border-radius: 10px;
  width: 350px;
  height : 250px;
  padding: 25px;
  @media screen and (max-width: 768px){
    width : 200px;
    height : 180px ;
  }
`;

export const BottomImageWrapper = styled.div`
  background: url(${BottomImage}) no-repeat;
  background-size: cover;
  background-position: -400px 100px;
`;
